import { render, staticRenderFns } from "./CustomerTrend.vue?vue&type=template&id=0c163862&"
import script from "./CustomerTrend.vue?vue&type=script&lang=js&"
export * from "./CustomerTrend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports